import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const PieChartWidget = ({ config = {} }) => {
  const title = config.title || 'Pie Chart';
  const showLegend = config.showLegend !== false;
  const innerRadius = config.donut ? (config.innerRadius || 50) : 0;
  const showLabels = config.showLabels !== false;
  const colors = config.colors || ['#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#EC4899', '#06B6D4', '#84CC16'];

  const demoData = config.data || [
    { name: 'Organic Search', value: 4500 },
    { name: 'Paid Search', value: 2300 },
    { name: 'Social Media', value: 1800 },
    { name: 'Direct', value: 1200 },
    { name: 'Referral', value: 800 },
    { name: 'Email', value: 600 }
  ];

  const RADIAN = Math.PI / 180;
  const renderLabel = ({ cx, cy, midAngle, innerRadius: ir, outerRadius, percent }) => {
    const radius = ir + (outerRadius - ir) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);
    return (
      <text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central" fontSize={11} fontWeight="600">
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div className="h-full flex flex-col bg-white p-3">
      <h3 className="text-sm font-semibold text-gray-700 mb-2" style={{ color: config.titleColor || '#374151' }}>
        {title}
      </h3>
      <div className="flex-1 min-h-0">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={demoData}
              cx="50%"
              cy="50%"
              innerRadius={innerRadius}
              outerRadius="80%"
              paddingAngle={config.paddingAngle || 2}
              dataKey="value"
              label={renderLabel}
              labelLine={false}
            >
              {demoData.map((entry, index) => (
                <Cell key={index} fill={colors[index % colors.length]} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => value.toLocaleString()} contentStyle={{ fontSize: 12, borderRadius: 8 }} />
            {showLegend && <Legend wrapperStyle={{ fontSize: 11 }} />}
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PieChartWidget;
